import { createFileRoute, redirect } from '@tanstack/react-router'

/**
 * `/portfolio/dashboard` — round one's single dashboard, kept for bookmarks
 * and for a chat card from before the move. My Dashboards is a section of
 * its own now (`/dashboards`, owner 2026-10-18); a replace keeps the old URL
 * out of the back stack. `component` never renders on a real visit.
 */
export const Route = createFileRoute('/_app/portfolio/dashboard')({
  beforeLoad: () => {
    // eslint-disable-next-line @typescript-eslint/only-throw-error
    throw redirect({ to: '/dashboards', replace: true })
  },
  component: () => null,
})
